export function round(value, decimals = 0) {
  const number = Number(value);
  if (Number.isNaN(number)) return 0;
  return Number(number.toFixed(decimals));
}

export function parseNumber(value, fallback = 0) {
  const number = parseFloat(value);
  return Number.isFinite(number) ? number : fallback;
}
